import { createElement } from "@wordpress/element";
/**
 * Internal dependencies
 */

/**
 * `PanelHeader` renders the header for the `Panel`.
 * This is used by the `Panel` component under the hood,
 * so it does not typically need to be used.
 */
function PanelHeader({
  label,
  children
}) {
  return createElement("div", {
    className: "components-panel__header"
  }, label && createElement("h2", null, label), children);
}
export default PanelHeader;
//# sourceMappingURL=header.js.map